<template>
    <span>{{ value }}</span>
</template>

<script>
import moment from 'moment';
import Vue from "vue";

export default Vue.extend({
  name: 'CellRendererDate',
  computed: {
    value () {

      const { value } = this.params;

      if (!value) {
        return '';
      }

      return moment(value).format('DD/MM/YYYY')
    }
  }
})
</script>
